const multipleData = {
  '国家标准': {
    // 'active': true,
    '状态': [
      {
        name: '已作废',
        id: '已作废',
        type: 'state'
      },
      {
        name: '现行有效',
        id: '现行有效',
        type: 'state'
      }
    ]
  },
  '行业标准': {
    '状态': [
      {
        name: '已作废',
        id: '已作废',
        type: 'state'
      },
      {
        name: '现行有效',
        id: '现行有效',
        type: 'state'
      }
    ],
    '行业类型': [
      {
        id: '1',
        name: '化工',
        type: 'trade'
      },
      {
        id: '2',
        name: '机械',
        type: 'trade'
      },
      {
        id: '3',
        name: '核行业',
        type: 'trade'
      },
      {
        id: '4',
        name: '电力',
        type: 'trade'
      },
      {
        id: '5',
        name: '石油天然气',
        type: 'trade'
      },
      {
        id: '6',
        name: '船舶',
        type: 'trade'
      },
      {
        id: '7',
        name: '纺织',
        type: 'trade'
      },
      {
        id: '8',
        name: '林业',
        type: 'trade'
      },
      {
        id: '9',
        name: '煤炭',
        type: 'trade'
      },
      {
        id: '10',
        name: '农业',
        type: 'trade'
      },
      {
        id: '11',
        name: '轻工',
        type: 'trade'
      },
      {
        id: '12',
        name: '汽车',
        type: 'trade'
      },
      {
        id: '13',
        name: '航天工业',
        type: 'trade'
      },
      {
        id: '14',
        name: '水利',
        type: 'trade'
      },
      {
        id: '15',
        name: '通信',
        type: 'trade'
      },
      {
        id: '16',
        name: '水产',
        type: 'trade'
      },
      {
        id: '17',
        name: '商业',
        type: 'trade'
      },
      {
        id: '18',
        name: '城镇建设',
        type: 'trade'
      },
      {
        id: '19',
        name: '环境保护',
        type: 'trade'
      },
      {
        id: '20',
        name: '烟草',
        type: 'trade'
      },
      {
        id: '21',
        name: '安全生产',
        type: 'trade'
      },
      {
        id: '22',
        name: '地质矿产',
        type: 'trade'
      },
      {
        id: '23',
        name: '建工',
        type: 'trade'
      },
      {
        id: '24',
        name: '航空',
        type: 'trade'
      },
      {
        id: '25',
        name: '有色冶金(金属)',
        type: 'trade'
      },
      {
        id: '26',
        name: '能源',
        type: 'trade'
      },
      {
        id: '27',
        name: '电子',
        type: 'trade'
      },
      {
        id: '28',
        name: '铁道',
        type: 'trade'
      },
      {
        id: '29',
        name: '民用航空',
        type: 'trade'
      },
      {
        id: '30',
        name: '石油化工',
        type: 'trade'
      },
      {
        id: '31',
        name: '交通',
        type: 'trade'
      },
      {
        id: '32',
        name: '卫生',
        type: 'trade'
      },
      {
        id: '33',
        name: '医药',
        type: 'trade'
      },
      {
        id: '34',
        name: '包装',
        type: 'trade'
      },
      {
        id: '35',
        name: '建材',
        type: 'trade'
      },
      {
        id: '36',
        name: '气象',
        type: 'trade'
      }
    ]
  }
//   '计量标准': {
//     '认证类别': [
//       {
//         id: '1',
//         name: '管理体系认证'
//       },
//       {
//         id: '2',
//         name: '服务认证'
//       },
//       {
//         id: '3',
//         name: '产品认证'
//       }
//     ],
//     '认证领域': [
//       {
//         id: '1',
//         name: '质量管理体系认证'
//       },
//       {
//         id: '2',
//         name: '环境管理体系认证'
//       },
//       {
//         id: '3',
//         name: '职业健康安全管理体系认证'
//       }
//     ],
//     '行政区划': [
//       {
//         id: '1',
//         name: '北京市'
//       },
//       {
//         id: '2',
//         name: '上海市'
//       },
//       {
//         id: '3',
//         name: '浙江省'
//       }
//     ]
//   },
//   '计量标准申请变更': {
//     '认证类别': [
//       {
//         id: '1',
//         name: '管理体系认证'
//       },
//       {
//         id: '2',
//         name: '服务认证'
//       },
//       {
//         id: '3',
//         name: '产品认证'
//       }
//     ],
//     '认证领域': [
//       {
//         id: '1',
//         name: '质量管理体系认证'
//       },
//       {
//         id: '2',
//         name: '环境管理体系认证'
//       },
//       {
//         id: '3',
//         name: '职业健康安全管理体系认证'
//       }
//     ],
//     '行政区划': [
//       {
//         id: '1',
//         name: '北京市'
//       },
//       {
//         id: '2',
//         name: '上海市'
//       },
//       {
//         id: '3',
//         name: '浙江省'
//       },
//       {
//         id: '4',
//         name: '辽宁省'
//       }
//     ]
//   }
}
export default multipleData



// WEBPACK FOOTER //
// ./src/layout/common/config/standard.js